// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "dd4230d9e096ecac1b2e" + ".chunk.js";
};